/**
 * @author: dwi.setiyadi@gmail.com
*/

/*
Startup Examples:

import { watcherModules } from '../modules/some/SagaSome';
export default [
  ...watcherModules,
];
*/

import { watcherSagaLogin } from '../modules/auth/redux';

export default [
  ...watcherSagaLogin,
];
